import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';

const enabledAxiosCacheAdapterLogs =
  process.env.ENABLE_AXIOS_CACHE_ADAPTER_LOGS === 'true';

const cache = setupCache({
  readHeaders: true,
  maxAge: 15 * 60 * 1000,
  limit: 1000,
  exclude: {
    query: false,
  },
  debug: enabledAxiosCacheAdapterLogs,
});

export const createHttp = (isSSR, apiConfig) => {
  return axios.create({
    headers: {
      'Cache-Control': 'no-cache',
      ...('headers' in apiConfig ? apiConfig.headers : {}),
    },
    adapter: isSSR ? cache.adapter : undefined,
    ...apiConfig,
  });
};



// WEBPACK FOOTER //
// ./src/remote/index.js